import styled, { css } from 'react-emotion'

export const playlistHeadDesktop = css`
  max-width: 45rem;
  color: #c8c8c8;
  margin: 1rem 0 2.4rem;

  .title {
    font-size: 2.8rem;
    font-weight: 200;
    color: #c8c8c8;
    line-height: 1.8;
  }

  .description {
    font-size: 1.4rem;
    font-weight: 100;
    line-height: 1.5;
    height: 6.3rem;
    text-transform: inherit;
    margin-bottom: 6rem;
    overflow: hidden;
  }
`

export const playlistHeadMobile = css`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-transform: inherit;
  color: #c8c8c8;
  height: 32vh;
  padding: 0;
  margin: 0;
  z-index: 1;

  .line {
    content: '';
    position: absolute;
    background-color: #d1d1d1;
    width: 14px;
    height: 1px;
    top: 50%;
    left: -20px;
  }

  .title {
    line-height: 1.8;
    font-size: 18px;
    font-weight: 200;
    position: relative;
    z-index: 1;
    padding: 0;
    margin-bottom: 6px;
    // background: linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0));
  }

  .description {
    position: relative;
    min-height: 55px;
    height: auto;
    line-height: 1.4;
    font-size: 13px;
    font-weight: 100;
    padding: 0 3.75rem 6px 0.75rem;
    z-index: 1;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 1) 25%, rgba(38, 41, 43, 1));
    overflow: hidden;
  }
`

export const playlistListContainer = css`
  // margin-right: 1rem;

  @media screen and (max-width: 640px) {
    // margin-top: 32px;

    .carouselWrapper {
      padding: 1rem 0 0 0 !important;
    }

    /* playlistListContainer */
    .slider-frame {
      padding: 0.5rem !important;
    }
  }
`

export const playlistList = css`
  min-width: 100%;
  margin-bottom: 4rem;

  @media screen and (max-width: 640px) {
    margin-bottom: 24px;
  }
`

export const imageContainer = css`
  position: relative;
  display: inline-block;
  width: 100%;
  border-radius: 0.25rem;
  transition: all 500ms ease 0s;
  overflow: hidden;

  :hover {
    pointer-events: auto;
    cursor: pointer;
    transform: scale(1.05);
  }
`

export const imagePlaceholder = css`
  display: inline-block;
  position: relative;
  z-index: 1;
  border-radius: 0.25rem;

  &.hide {
    position: absolute;
    z-index: 0;
  }
`

export const imageWrapper = css`
  position: relative;
  display: inline-block;
  text-align: left;
  width: 100.5%;
  overflow: hidden;

  img {
    display: inline-block;
    position: relative;
    z-index: 1;
    border-radius: 0.25rem;
  }
`

export const CarouselWrapper = styled('div')`
  // overflow: hidden;
  padding: 1rem 0 0 !important;
  height: ${props => props.height || 'auto'};
  min-height: ${props => props.minHeight || '300px'};

  .slider-frame {
    padding: 0 !important;
    overflow: visible !important;
  }

  .slider-control-centerright {
    right: -2.5% !important;
  }

  .slider-control-centerleft {
    left: -2.5% !important;
  }

  @media screen and (min-width: 1600px) {
    .slider-control-centerright {
      right: -1.8% !important;
    }

    .slider-control-centerleft {
      left: -1.8% !important;
    }
  }
`

export const playlistCarousel = css`
  .slider-frame {
    margin: 0 !important;
  }
`

export const playlistCarouselContainer = css`
  padding: 1rem 0 0 0 !important;
`

export const PlaylistInlineWrapper = styled('div')`
  display: inline-block;
  vertical-align: top;
  width: ${props =>
    props.isMobile
      ? props.isLandscape
        ? 'calc((100% - 3.2rem) / 2)'
        : 'calc((100% - 3.2rem) / 3)'
      : props.isLandscape
      ? 'calc((100% - 6.4rem) / 4)'
      : 'calc((100% - 9.6rem) / 6)'};
  margin: ${props =>
    props.isMobile ? (props.isLandscape ? '0 1.6rem 3.2rem 0' : '0 0.8rem 3.2rem 0') : '0 1.6rem 3.2rem 0'};
  min-height: 0;
  min-width: 0;
  overflow: hidden;

  @media screen and (max-width: 640px) {
    &:nth-of-type(3n) {
      margin: ${props => (props.isMobile ? '0 1.6rem 3.2rem 0' : '')};
    }
  }
`

export const playlistHeader = css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  div.mola-ori-header {
    transform: translate(0.5rem, 5rem);
    margin-left: 0.5rem;
    position: relative;
    z-index: 1;
  }

  div.mola-ori-header > h3 {
    color: #ffffff;
  }

  h3 {
    padding: 0;
    color: #cbcbcb;
    font-size: 1.5rem;
    display: inline-block;
    vertical-align: middle;
    font-weight: 400;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    width: auto;
    height: 1.25rem;
    font-weight: 400;
    color: #969696;
    // border: 0.112rem solid #969696;
    border-radius: 3rem;
    padding: 0.5rem 0;
    transition: all ease 500ms;
    z-index: 103;
  }

  a:hover {
    color: #ffffff;
    // background: white;
    // border: 0.112rem solid #ffffff;
  }

  @media screen and (max-width: 640px) {
    a {
      z-index: 1;
    }
  }

  @media screen and (max-width: 640px) {
    div.mola-ori-header {
      transform: none;
      position: relative;
      z-index: 1;
    }

    h3 {
      color: #cbcbcb;
      font-size: 15px;
      margin: 0;
    }

    a {
      font-size: 12px;
      margin: 0;
      padding: 5px 0;
      border-width: 1px;
    }
  }
`

export const playlistHeaderTitle = css`
  h3 {
    padding: 0;
    color: #cbcbcb;
    font-size: 1.5rem;
    display: inline-block;
    vertical-align: middle;
    font-weight: 400;
    line-height: 1.5;
  }
`

export const playlistHeaderDescription = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  a {
    font-size: 1.2rem;
    line-height: 1.5;
    font-weight: 400;
    color: #969696;
  }
`

export const BannerWrapper = styled('div')`
  padding-top: 1rem;
  margin: -0.5rem 0 4rem;

  @media screen and (max-width: 640px) {
    margin: -6px 0 32px;
  }
`

export const playlistDescription = css`
  margin: 0.4rem 0 0;
  color: #838586;
  font-size: 1.4rem;
  line-height: 1.5;
  display: inline-block;
  vertical-align: middle;
  font-weight: 400;
  width: 40%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media screen and (max-width: 640px) {
    width: 76%;
  }
`

export const MolaOriCarouselWrapper = styled('div')`
  // overflow: hidden;
  height: ${props => props.height || 'auto'};
  min-height: ${props => props.minHeight || '300px'};
  margin-bottom: 4rem;

  @media screen and (max-width: 640px) {
    margin-bottom: 32px;
  }

  @media screen and (max-width: 1024px) {
    // min-height: 23rem;

    .slider-control-centerleft {
      left: 10px;
    }
  }

  @media screen and (max-width: 768px) {
    // min-height: 18rem;

    .slider-control-centerright {
      right: -3rem !important;
    }

    .slider-control-centerleft {
      left: -3rem !important;
    }

    .slider-control-centerright span,
    .slider-control-centerleft span {
      width: 1.5rem;
    }
  }

  .slider-frame {
    padding: 0 !important;
    overflow: visible !important;
  }
`
